'use strict';

angular.module('webmailWrapper')
    .service('browserSettings', function($window) {
        this.cookieEnabled = function() {
            return $window.navigator.cookieEnabled;
        };
    });
